"use client";

import React from 'react';
//import { useState, useEffect } from 'react';
//import { motion, AnimatePresence } from 'framer-motion';
import { Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import MainPage from './pages/MainPage';

import PrivateRoute from './PrivateRoute';
import { AuthProvider } from './AuthContext';

import { SessionProvider } from './components/SessionDropdown';
import { LanguageProvider } from './components/LanguageDropdown';

import './styles/animations.css';
import './styles/custom-scrollbar.css';
import './styles/file-upload.css';
import './styles/mobile.css';

const App: React.FC = () => (
  <AuthProvider>
    <LanguageProvider>
      <SessionProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><MainPage /></PrivateRoute>} />
        </Routes>
      </SessionProvider>
    </LanguageProvider>
  </AuthProvider>
);

export default App;
